import React from "react";

import { StatisticsButton } from "@features/offer/desktop/buttons";
import { useOfferHistoryColumns } from "@features/offer/desktop/view/components/tournament-events/OfferHistoryColumnsContext";
import { Event, Sport } from "@gp/models";
import { getOfferHistoryScore } from "@utils/offer/offerHistoryScore";
import classnames from "classnames";
import { observer } from "mobx-react";

export const OfferHistoryMatchResult = observer(
	function OfferHistoryMatchResult(props: {
		isOnHomepage?: boolean;
		isEventFeatured?: boolean;
		isAdditionalOfferVisible?: boolean;
		event: Event;
		sport: Sport;
		isSpotlight?: boolean;
	}) {
		const { isAdditionalOfferVisible } = props;
		const score = getOfferHistoryScore(props.event.result);
		const columns = useOfferHistoryColumns();

		const columnClasses = classnames("offer__body__data offer__result", {
			"offer__result--lrg":
				!isAdditionalOfferVisible && props.sport.abrv == "cricket",
			"offer__result--sml": isAdditionalOfferVisible,
		});

		return (
			<>
				{columns.hasResult && (
					<div
						className={classnames(
							columnClasses,
							"offer__result--ft"
						)}
					>
						<div className="offer__result__team">
							{score.fullTime?.home}
						</div>
						<div className="offer__result__team">
							{score.fullTime?.away}
						</div>
					</div>
				)}
				<div className="flex u-mar--left--sml u-mar--right--sml">
					<StatisticsButton isOfferButton />
				</div>
			</>
		);
	}
);
